import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { BgColorOptions, ColorOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
interface TextListItem {
    text: string;
}
interface IPageComponentHeroValuePropositionBarData extends NICmsContentComponent.IData {
    text_color?: string;
    background_color?: string;
    animation_duration: number;
    text_list: TextListItem[];
    divider?: string;
}
@ICmsComponent<PageComponentHeroValuePropositionBarComponent>({
    id: 'hero-value-proposition-bar',
    name: 'Hero value proposition bar',
    tags: ['value', 'hero'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'text_color',
            title: 'Text color',
            type: NICmsContentField.EFieldType.choice,
            options: ColorOptions,
            default: 'col-b',
            previewMode: 'color'
        },
        <NICmsContentField.IChoiceField>{
            key: 'background_color',
            title: 'Background color',
            type: NICmsContentField.EFieldType.choice,
            options: BgColorOptions,
            default: 'bg-col-44',
            previewMode: 'color'
        },
        <NICmsContentField.INumberField>{
            key: 'animation_duration',
            title: 'Animation duration',
            type: NICmsContentField.EFieldType.number,
            default: 90,
            min: 0,
            max: 100,
            required: true,
            description: 'Set speed on animation in seconds ( 0 - 100 )'
        },
        {
            key: 'divider',
            title: 'Divider icon',
            type: NICmsContentField.EFieldType.image
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'text_list',
            title: 'Text list',
            itemName: 'text',
            required: true,
            defaultSize: 3,
            fields: [
                {
                    key: 'text',
                    title: 'Text',
                    type: NICmsContentField.EFieldType.text,
                    default: 'text',
                    required: true
                }
            ],
            default: [
                {
                    text: '#lovelemieux'
                },
                {
                    text: 'Express Delivery'
                }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-hero-value-proposition-bar',
    templateUrl: './hero-value-proposition-bar.html',
    styleUrls: ['hero-value-proposition-bar.scss'],
    standalone: true,
    imports: [NgClass, ImageModule, ICmsClientModule, NgIf, NgFor],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentHeroValuePropositionBarComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentHeroValuePropositionBarData;
}
